import { useMemo } from 'react';

import useFetch from 'hooks/useFetch';

import { CONTENT_TYPE_JSON, FLIGHT_PLANNER_BASE_URL } from './constants';
import type { UsePlannerFetchReturn } from './types';

const PLANNER_FETCH_PARAMS = {
    apiHost: FLIGHT_PLANNER_BASE_URL,
    headers: {
        Accept: CONTENT_TYPE_JSON,
        'Content-Type': CONTENT_TYPE_JSON
    },
    retrieveToken: undefined
};

const usePlannerFetch = (): UsePlannerFetchReturn => {
    const { httpDelete, httpGet, httpPost } = useFetch(PLANNER_FETCH_PARAMS);

    return useMemo(
        () => ({
            plannerDelete: httpDelete,
            plannerGet: httpGet,
            plannerPost: httpPost
        }),
        [httpDelete, httpGet, httpPost]
    );
};

export default usePlannerFetch;
